import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "config/config";

export const baseQueryConfig = fetchBaseQuery({
  baseUrl: `${BASE_URL}`,
  prepareHeaders: (headers, { getState }) => {
    // Récupérer le token dans le state redux (exemple)
    const token = getState().auth.token; // adapte selon ton store

    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
  credentials: "include", // si tu utilises les cookies, sinon retire
});
